import dataFetchingClient from './DataFetchingClient';
import produce from 'immer';
export const getQueryFieldName = query => {
  return query.definitions[0].name.value;
};
export const queryDataFromCache = (query, variables) => {
  const fieldName = getQueryFieldName(query);
  const queryDataWrapper = dataFetchingClient.cache.readQuery({
    query,
    variables
  });
  return queryDataWrapper ? queryDataWrapper[fieldName] : null;
};
export const updateCache = (query, updateFn, variables) => {
  const fieldName = getQueryFieldName(query);
  dataFetchingClient.cache.writeQuery({
    query,
    data: {
      [fieldName]: produce(queryDataFromCache(query, variables) || {}, updateFn)
    },
    variables
  });
};